import { createContext } from 'react'

import { createAttachmentCardStore } from '../store/createStore'

export const AttachmentCardStoreContext = createContext<
  ReturnType<typeof createAttachmentCardStore> | undefined
>(undefined)
